import styled, { css } from 'styled-components';
export const DashboardWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - 110px);
  position: relative;
  padding: 16px;
  background: var(--white);
  
  @media (min-width: 1440px) {
    padding: 20px;
  }

  &.step-mode {
    padding: 0;
    min-height: calc(100dvh - 165px);
    transition: all 0.350s ease-in-out;


    .trial-banner-visible & {
        min-height: calc(100dvh - 250px);
    }
  }

`;

export const CampaignHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 0 10px;
  padding: 6px 8px;
  border-radius: 50px;
  border: 1px solid #f4f4f5;

  @media (min-width: 1440px) {
    margin: 0 0 20px;
  }

  ${({ $noBorder }) => $noBorder && css`
  border: none;
  padding: 0;
`}

${({ $fixed }) => $fixed && css`
  position: sticky;
  top: 50px;
  z-index: 1;
  background: var(--white);
  padding: 10px 0  ;
  margin: 0 ;
  border-radius:0 ;
  
  @media (min-width: 1450px) {
    top: 60px;
    margin: 0 ;
    padding:  20px 0;
  }
  .trial-banner-visible & {
    top: 92px;
    @media (min-width: 1450px) {
    top: 100px;
    }
  }
`}


.dropdown-holder {
  width: 140px;
  border-radius: 50px;
  
  button {
   @media (max-width: 1449px) {
    padding: 8px 12px;
   }
  }
  
  &.campaign-select {
    width: 200px;
  }
  
}

button {
 @media (max-width: 1449px) {
  padding: 8px 12px;
 }
}

.btn-holder {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    max-width: 300px;
  }


`;

export const DetailStyle = styled.div`
  position: relative;
  margin: 0 0 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  /* flex-grow: 1; */

  @media (min-width: 1440px) {
    gap: 20px;
    margin: 0 0 20px;
  }
`;

export const InfoColumn = styled.div`
  min-height: 133px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  color: var(--black);
  padding: 12px;
  border-radius: 15px;
  border: 1px solid #f4f4f5;
  background: var(--white);

  @media (min-width: 1450px) {
    padding: 20px 15px;
  }

  ${({ height }) =>
    height &&
    css`
      min-height: 103px;

      .graph-box {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        right: 15px;
      }
    `}

  .subtitle {
    display: block;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    margin: 0 0 5px;

    @media (min-width: 1440px) {
      margin: 0;
      font-size: 18px;
      line-height: 22px;
    }
  }

  .wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px;
    overflow: hidden;
  }

  .value {
    display: block;
    font-size: 26px;
    line-height: 30px;
    font-weight: 600;
    margin: 0 0 10px;

    @media (min-width: 1200px) {
      font-size: 30px;
      line-height: 34px;
    }
    @media (min-width: 1440px) {
      font-size: 40px;
      line-height: 44px;
    }

    &:only-child {
      margin: 0;
    }
  }

  .text {
    display: block;
    font-size: 12px;
    line-height: 15px;
    font-weight: 400;

    @media (min-width: 1500px) {
      /* font-size: 14px;
      line-height: 17px; */
    }

    .green {
      color: #01c638;
    }
  }

  .graph-box {
    width: 60px;
    padding: 0;
    border-radius: 10px;

    @media (min-width: 1200px) {
      width: 100px;
    }

    ${({ hasPadding }) =>
    hasPadding &&
    css`
        padding: 5px;
        width: 70px;
        height: 60px !important;

        @media (min-width: 1200px) {
          width: 70px;
        }

        .highcharts-container {
          /* height: 60px !important; */
        }
      `}
  }
`;
